'use client'

import AgentTemplates from '@/components/Dashboard/AgentTemplates'
import Coming from '@/components/Landing/Coming'
import Footer from '@/components/Landing/Footer'
import Header from '@/components/Landing/Header'
import Hero from '@/components/Landing/Hero'
import Step from '@/components/Landing/Step'
import SuperpowersGrid from '@/components/Landing/SuperpowersGrid'
import TemplateRedirectOverlay from '@/components/Landing/TemplateRedirectOverlay'
import MetaPixel from '@/components/MetaPixel'
import { useGetUserQuery } from '@/lib/features/user/userApi'
import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react'

const LandingPage: React.FC = () => {
  const { data: userData } = useGetUserQuery()
  const workspace = userData?.workspace

  const [isScrolled, setIsScrolled] = useState(false)
  const scrollRef = useRef<HTMLDivElement>(null!)

  // Hydration-safe templateRedirect logic
  const [templateRedirect, setTemplateRedirect] = useState<string | null>(null)
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    setTemplateRedirect(queryParams.get('templateRedirect'))
  }, [])

  const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
    const scrollPosition = event.currentTarget.scrollTop
    if (scrollPosition > 300) {
      setIsScrolled(true)
    } else {
      setIsScrolled(false)
    }
  }, [])

  return (
    <div className="min-h-screen w-full max-w-[100vw] overflow-x-hidden bg-[#F2F3F7] text-black">
      <Suspense fallback={null}>
        <MetaPixel />
      </Suspense>
      {templateRedirect ? <TemplateRedirectOverlay agentId={templateRedirect} /> : null}
      <div
        ref={scrollRef}
        className="absolute left-0 top-0 z-10 h-full w-full overflow-x-hidden overflow-y-scroll"
        onScroll={handleScroll}
      >
        <Header scrollRef={scrollRef} />

        <Hero isScrolled={isScrolled} isHidden={!workspace?.id} />
        <div id="templates-section" className="mt-[128px]">
          <AgentTemplates headerText="Start building from a template" />
        </div>
        <div id="capabilities-section" className="mt-16">
          <SuperpowersGrid />
        </div>
        <div className="mt-16">
          <Step />
        </div>
        <div className="mt-16">
          <Coming />
        </div>
        <div className="mt-16 h-[80px] w-full bg-gradient-to-b from-transparent to-[#eee7dc]"></div>
        <Footer />
      </div>
    </div>
  )
}

export default LandingPage
